module.exports = __webpack_public_path__ + "img/tail_grey.17e28ab6.svg";